import Immutable from 'immutable';

import * as Constants from 'const';
import * as Models from 'models';
import { getDesktopBrandStyles } from 'utils/brandStyles';
import { getBackgroundColorFromBrandStyle, getFontColorFromBrandStyle } from 'utils/brandStyles/getColorTypeFromBrandStyle';
import { boxPropertiesFromString } from 'utils/converters';
import { getBrandFontRefFromBrandStyle } from './utils';

// TODO: the function should be devided on several functions
export function getTextStylesFromBrandStyle(
  style: Models.BrandStyleMap | undefined,
  colors: Models.BrandColorsList,
  fonts: Models.BrandFontsList,
): Models.TextBrandStyles {
  let backgroundColor: Models.BrandColorMap = null;
  let bulletColor: string = Constants.DefaultCustomStyle.FONT_COLOR;
  let characterStyle: string = null;
  let fontColor: string = Constants.DefaultCustomStyle.FONT_COLOR;
  let fontFamily: string = Constants.DefaultCustomStyle.FONT_FAMILY;
  let fontSize: number = Constants.DefaultCustomStyle.FONT_SIZE;
  let lineHeight = Constants.DefaultLineHeight;
  let padding = Immutable.Map(Constants.Styles.DefaultTextPadding);
  let textAlign = Constants.DefaultTextAlignment;
  let verticalAlignment = Constants.AssetAlignmentType.TOP;

  if (style) {
    const desktopStyles = getDesktopBrandStyles(style);

    // Variables section
    // Inline styles
    fontSize = parseInt(desktopStyles.get(Models.BrandStyleProp.FONT_SIZE), 10);
    fontColor = getFontColorFromBrandStyle(desktopStyles.get(Models.BrandStyleProp.COLOR), colors, desktopStyles, fonts);

    const brandFontRef = getBrandFontRefFromBrandStyle(desktopStyles, fonts);
    // null values repeats the existing behviour
    fontFamily = brandFontRef?.fontName ?? null;
    characterStyle = brandFontRef?.characterStyleName ?? null;

    // Paragraph styles
    lineHeight = Number(desktopStyles.get(Models.BrandStyleProp.LINE_HEIGHT));
    textAlign = desktopStyles.get(Models.BrandStyleProp.TEXT_ALIGN);

    // Cell styles
    backgroundColor = getBackgroundColorFromBrandStyle(colors, desktopStyles);
    bulletColor = desktopStyles.get(Models.BrandStyleProp.BULLET_COLOR) ?? bulletColor;
    padding = boxPropertiesFromString<Models.PaddingMap>(desktopStyles.get(Models.BrandStyleProp.PADDING));
    verticalAlignment = desktopStyles.get(Models.BrandStyleProp.VERTICAL_ALIGN);
  }

  return {
    backgroundColor,
    bulletColor,
    characterStyle,
    fontColor,
    fontFamily,
    fontSize,
    lineHeight,
    padding,
    textAlign,
    verticalAlignment,
  };
}
